import api from "./axios";

interface UsageHistoryParams {
  type: string;
  email: string;
  start_time: string;
  end_time: string;
  token: string | undefined;
}

export const sendUsageHistory = (params: UsageHistoryParams) => {
  return api.get("/api/web-api/send-usage-history", {
    headers: {
      "x-session-token": params.token,
    },
    params: {
      type: params.type.toLowerCase(),
      email: params.email,
      start_time: params.start_time,
      end_time: params.end_time,
    },
  });
};
